import { z } from 'zod';
// Schema for tilemap object properties
const TilePropertySchema = z.object({
    name: z.string(),
    type: z.string(),
    value: z.any()
});
// Schema for tilemap object
const TilemapObjectSchema = z.object({
    id: z.number().optional(), // Unique ID for the object within the layer
    gid: z.number(),
    x: z.number(),
    y: z.number(),
    width: z.number(),
    height: z.number(),
    rotation: z.number().optional(),
    visible: z.boolean().optional(),
    properties: z.array(TilePropertySchema).optional(),
    polygon: z.array(z.object({
        x: z.number(),
        y: z.number()
    })).optional(),
    ellipse: z.boolean().optional(),
    point: z.boolean().optional()
});
// Schema for decorations layer
export const DecorationsLayerSchema = z.object({
    name: z.string(),
    visible: z.boolean(),
    objects: z.array(TilemapObjectSchema)
});
// Schema for tile data
const TileDataSchema = z.object({
    id: z.number(),
    image: z.string().optional(),
    imagewidth: z.number().optional(),
    imageheight: z.number().optional(),
    properties: z.array(TilePropertySchema).optional()
});
// Schema for tilemap tileset
export const TilemapTilesetSchema = z.object({
    firstgid: z.number(),
    name: z.string(),
    tilecount: z.number().optional(),
    tiles: z.array(TileDataSchema).optional()
});
// Schema for complete tilemap data
export const TilemapDataSchema = z.object({
    width: z.number(),
    height: z.number(),
    layers: z.array(z.any()), // Complex layer types, kept as any for flexibility
    tilesets: z.array(TilemapTilesetSchema)
});
// Schema for decoration change operations
export const DecorationChangeSchema = z.object({
    type: z.enum(['add', 'update', 'remove']),
    object: TilemapObjectSchema.optional(),
    objectId: z.number().optional(), // For update/remove operations
    oldObject: TilemapObjectSchema.optional() // For update operations, to find the object to update
});
// Schema for batch update payload
export const BatchUpdatePayloadSchema = z.object({
    roomId: z.string().uuid(),
    changes: z.array(DecorationChangeSchema)
});
// Schema for decorations update request
export const UpdateDecorationsRequestSchema = z.object({
    roomId: z.string(),
    changes: z.array(DecorationChangeSchema)
});
// Schema for decorations response
export const DecorationsResponseSchema = z.object({
    success: z.boolean(),
    data: DecorationsLayerSchema.nullable().optional(),
    message: z.string().optional(),
    error: z.string().optional()
});
